import { GridColDef } from '@mui/x-data-grid';

export const CoinTypeTableColumns: GridColDef[] = [
  {
    minWidth: 150,
    field: 'symbol',
    headerName: 'Symbol',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 400,
    field: 'contractAddr',
    headerName: 'Contract Address',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 150,
    field: 'network',
    headerName: 'Network',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

export const AdminWalletTableColumns: GridColDef[] = [
  {
    minWidth: 350,
    field: 'address',
    headerName: 'Address',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 150,
    field: 'name',
    headerName: 'Name',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    valueFormatter: (params) => params.value || '-',
  },
  {
    minWidth: 200,
    field: 'description',
    headerName: 'Description',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    valueFormatter: (params) => params.value || '-',
  },
  {
    minWidth: 100,
    field: 'isActiveText',
    headerName: 'Active',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 180,
    field: 'createdAtFormatted',
    headerName: 'Created At',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

export const StakeDbPoolListTableColumns: GridColDef[] = [
  {
    minWidth: 150,
    field: 'poolId',
    headerName: 'Pool ID',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'title',
    headerName: 'Title',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 100,
    field: 'tokenSymbol',
    headerName: 'Token',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 150,
    field: 'stateFilter',
    headerName: 'State',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 100,
    field: 'isHiddenFilter',
    headerName: 'Hidden',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 100,
    field: 'poolType',
    headerName: 'Pool Type',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    valueFormatter: (params) => {
      if (params.value === '1') return 'balancer';
      return 'assetfi';
    },
  },
  {
    minWidth: 150,
    field: 'targetUsdt',
    headerName: 'Target USDT',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 100,
    field: 'interestRate',
    headerName: 'Interest Rate',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    valueFormatter: (params) => {
      if (params.value) {
        return `${params.value}%`;
      }
      return '-';
    },
  },
  {
    minWidth: 100,
    field: 'claimDay',
    headerName: 'Claim Day',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    valueFormatter: (params) => params.value ?? '-',
  },
  {
    minWidth: 180,
    field: 'fundingStartAt',
    headerName: 'Funding Start',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    valueFormatter: (params) => params.value || '-',
  },
  {
    minWidth: 180,
    field: 'fundingEndAt',
    headerName: 'Funding End',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    valueFormatter: (params) => params.value || '-',
  },
  {
    minWidth: 180,
    field: 'operationStartAt',
    headerName: 'Operation Start',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    valueFormatter: (params) => params.value || '-',
  },
  {
    minWidth: 180,
    field: 'operationEndAt',
    headerName: 'Operation End',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    valueFormatter: (params) => params.value || '-',
  },
];

// Dashboard - Stake
export const StakeDbDashboardStakeColumns: GridColDef[] = [
  {
    minWidth: 350,
    field: 'walletAddress',
    headerName: 'address',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 500,
    field: 'title',
    headerName: 'title',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },
  {
    minWidth: 130,
    field: 'ticker',
    headerName: 'ticker',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'stakeAmount',
    headerName: 'stake amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'adjustedStakeAmount',
    headerName: 'adjusted amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'usdtValue',
    headerName: 'usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'adjustedUsdtValue',
    headerName: 'adjusted usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'createdAt',
    headerName: 'created at',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 180,
    field: 'fundingStartAt',
    headerName: 'funding start',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 180,
    field: 'fundingEndAt',
    headerName: 'funding end',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

// Dashboard - Unstake
export const StakeDbDashboardUnstakeColumns: GridColDef[] = [
  {
    minWidth: 350,
    field: 'walletAddress',
    headerName: 'address',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 500,
    field: 'title',
    headerName: 'title',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },
  {
    minWidth: 130,
    field: 'ticker',
    headerName: 'ticker',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'stakeAmount',
    headerName: 'stake amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'usdtValue',
    headerName: 'usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'createdAt',
    headerName: 'created at',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 180,
    field: 'fundingStartAt',
    headerName: 'funding start',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 180,
    field: 'fundingEndAt',
    headerName: 'funding end',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

// Dashboard - Reward
export const StakeDbDashboardRewardColumns: GridColDef[] = [
  {
    minWidth: 350,
    field: 'walletAddress',
    headerName: 'address',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 500,
    field: 'title',
    headerName: 'title',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },
  {
    minWidth: 130,
    field: 'rewardTicker',
    headerName: 'reward ticker',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'rewardAmount',
    headerName: 'reward amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'rewardUsdt',
    headerName: 'reward usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'createdAt',
    headerName: 'created at',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 180,
    field: 'fundingStartAt',
    headerName: 'funding start',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 180,
    field: 'fundingEndAt',
    headerName: 'funding end',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];

// Dashboard - Withdraw
export const StakeDbDashboardWithdrawColumns: GridColDef[] = [
  {
    minWidth: 350,
    field: 'walletAddress',
    headerName: 'address',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 500,
    field: 'title',
    headerName: 'title',
    headerAlign: 'center',
    align: 'left',
    sortable: false,
  },
  {
    minWidth: 130,
    field: 'ticker',
    headerName: 'ticker',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'stakeAmount',
    headerName: 'withdraw amt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'usdtValue',
    headerName: 'usdt',
    headerAlign: 'center',
    align: 'right',
    sortable: false,
  },
  {
    minWidth: 200,
    field: 'createdAt',
    headerName: 'created at',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 180,
    field: 'fundingStartAt',
    headerName: 'funding start',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
  {
    minWidth: 180,
    field: 'fundingEndAt',
    headerName: 'funding end',
    headerAlign: 'center',
    align: 'center',
    sortable: false,
  },
];
